jQuery(document).ready(function(){
  $('.values-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-thumbnails'
  });
  
  $('.slider-thumbnails').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.values-slider',
      centerMode: true,
      focusOnSelect: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
  });
});